<script setup lang="ts" generic="T extends VolleyballAttributeId">
import { ref } from 'vue'

import {
  TeamSide,
  VolleyballAttributeId,
} from '@collector/sportsapi-client-legacy'
import Button from '@mobile/components/Button/Button.vue'
import IncidentBasicInfo from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/IncidentBasicInfo.vue'
import Modal from '@mobile/views/Relation/DetailsPanel/Modals/Modal.vue'
import ModalButtons from '@mobile/views/Relation/DetailsPanel/Modals/ModalButtons.vue'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import FieldZonesPitch from './FieldZonesPitch.vue'

type Props = {
  linkedIncident: ProbableLinkedIncident
  incidentParticipantTeamSide: TeamSide
  zones: Map<number, VolleyballAttributeId>
}
const props = defineProps<Props>()

// emits
interface Emits {
  close: []
  save: [{ selectedZone: number | null }]
}
defineEmits<Emits>()

// state
const selectedZone = ref<number | null>(getIncidentZoneAttributeIndex())

// methods
function getIncidentZoneAttributeIndex(): number | null {
  const { incident } = props.linkedIncident

  if (incident.attribute_ids.length === 0) {
    return null
  }

  for (const [zone, attributeId] of props.zones.entries()) {
    if (incident.attribute_ids.includes(attributeId)) {
      return zone
    }
  }

  return null
}
</script>

<template>
  <Modal id="incidentDetailsModal">
    <IncidentBasicInfo :linkedIncident />

    <div class="space-y-4 py-4">
      <slot />
      <FieldZonesPitch
        v-model:selectedZone="selectedZone"
        :incidentParticipantTeamSide
      />
    </div>

    <ModalButtons>
      <Button
        color="red"
        :size="'lg'"
        @click="$emit('close')"
      >
        Close
      </Button>
      <Button
        class="px-8"
        color="green"
        :size="'lg'"
        @click="$emit('save', { selectedZone })"
      >
        Save
      </Button>
    </ModalButtons>
  </Modal>
</template>
